const supportedFullLocales = ['fr-BE', 'de-BE', 'nl-BE', 'nl-NL'];

export default function getContentfulLocale(locale?: string, market?: string) {
  // 05/05/2025: We are planning on switching to a four character local scheme for every request.
  // Currently, for non-English locales, we are only sending a two character value (e.g. "fr").
  // Until Contentful is fully configured, we will need to selectively handle these cases.
  const contentfulConfigEl = document.getElementById('contentful-config');
  const siteRegion = contentfulConfigEl?.dataset?.region || '';
  const fullLocale = contentfulConfigEl?.dataset?.locale || '';
  if (fullLocale && supportedFullLocales.includes(fullLocale)) {
    return fullLocale;
  }

  if (locale == 'en' && (market == 'australia' || market == 'au')) {
    return 'en-AU';
  }
  
  if (locale == 'en' && (market == 'uk' || market == 'gb')) {
    return 'en-GB';
  }

  if (locale == 'en' && (siteRegion == 'EMEA' || market == 'emea' || market == 'eu')) {
    return 'en-EU';
  }

  if (locale == 'en' || !locale) {
    return 'en-US';
  }

  return locale;
}